import { Box, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { colors, VStack } from "goi_common";
import styled from "@emotion/styled";
import { CarouselCard } from "./CarouselCard";
import { 가족장2026 } from "goi_common/src/constants/servicePackages/service2026/가족장";

export default function CommonPackageExtraDetails({ type }: { type?: string }) {
  const extraDetails = 가족장2026.extraDetails;
  return (
    <>
      {extraDetails &&
        extraDetails.map(({ key, contents }) => {
          // contents가 객체인 경우 모든 카테고리의 상품들을 하나의 배열로 합치기
          if (
            contents &&
            typeof contents === "object" &&
            !Array.isArray(contents)
          ) {
            // Object.values(contents)는 배열들의 배열이므로 flat()으로 평탄화
            const allProducts = Object.values(contents).flat();

            return (
              <CarouselCard key={key} title={key} contents={allProducts} />
            );
          }
          // contents가 배열인 경우 기존 로직 유지
          return (
            <CarouselCard
              key={key}
              title={key}
              contents={Array.isArray(contents) ? contents : []}
            />
          );
        })}

      <VStack
        gap={24}
        width="100%"
        margin="20px 0 0 0"
        background={colors.warmGray150}
        padding="12px 0"
        borderRadius="10px"
      >
        <VStack
          gap={6}
          background={colors.white}
          margin="24px 20px 0"
          padding="10px 12px"
          borderRadius="5px"
          alignItems="center"
        >
          <div className="subtitle_16_b black">
            기타 추가 비용 상세(발생 시)
          </div>
        </VStack>
        <Box padding="0 24px 24px">
          <Table className="caption_12_m">
            <Thead>
              <Tr>
                <DenseTh width="150px">품목</DenseTh>
                <DenseTh textAlign="center">단위</DenseTh>
                <DenseTh textAlign="right">비용</DenseTh>
              </Tr>
            </Thead>
            <Tbody textAlign="center">
              <Tr>
                <DenseTd className="caption_12_b">도로교통비</DenseTd>
                <DenseTd textAlign="center">km 당</DenseTd>
                <DenseTd textAlign="right">2,000원</DenseTd>
              </Tr>
              <Tr>
                <DenseTd className="caption_12_b">4일장, 5일장</DenseTd>
                <DenseTd textAlign="center">일비(일당)</DenseTd>
                <DenseTd textAlign="right">
                  {type === "무빈소장" ? "15만원" : "20만원"}
                </DenseTd>
              </Tr>
              <Tr>
                <DenseTd className="caption_12_b">특수염(사고사 등)</DenseTd>
                <DenseTd textAlign="center">1회</DenseTd>
                <DenseTd textAlign="right">최대 50만원</DenseTd>
              </Tr>
            </Tbody>
          </Table>
        </Box>
      </VStack>
    </>
  );
}

const DenseTd = styled(Td)`
  padding: 8px 12px;
  border-bottom: 1px solid ${colors.warmGray400};
`;
const DenseTh = styled(Th)`
  padding: 8px 12px;
  border-bottom: 2px solid ${colors.warmGray500};
`;
